// This file has been auto-generated for msk-us in vite-plugin-generate-localisation.js. Do not edit directly.
import en from './en-msk.json'
import es from './es_US-msk.json'
export default { en, es }
